module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/passthrough.js
// module id = 1024
// module chunks = 4